export var EVENTS_EVENT_TYPES = {
  ENTER_EVENTS_SCREEN: 'ENTER_EVENTS_SCREEN',
  DISPLAY_EVENTS_ICON: 'DISPLAY_EVENTS_ICON',
  EVENTS_OPEN_EVENT_CARD: 'EVENTS_OPEN_EVENT_CARD',
  EVENTS_OPEN_INFO_SCREEN: 'EVENTS_OPEN_INFO_SCREEN',
  DISPLAY_EVENTS_TOOLTIP: 'DISPLAY_EVENTS_TOOLTIP',
  DISPLAY_EVENTS_TUTORIAL: 'DISPLAY_EVENTS_TUTORIAL',
  SKIP_EVENTS_TUTORIAL: 'SKIP_EVENTS_TUTORIAL'
};